/* sts-ab.js - the routine-builder picker A/B test (Luis, 2026-09-29). Loaded by
   snippets/sts-ab.liquid on the quiz, the results page and the Skin Profile,
   the three pages with a step picker ("{Category} Options Right For You",
   "Other options for this step").

   ARMS, per device, stable: localStorage "sts.ab.routine_picker" = all | few
   (sessionStorage when localStorage throws, else this page only).
     all  every option: the routine reads and writes ask for ?swaps=all (up to
          24 per step from the backend; see swaps() below), only approved ones
          where the payload says, and the list is scrolled, never cut. No
          "Don't see one you like?" link.
     few  the product in use plus at most 3 alternatives: the original pick
          when the step was swapped away from it (so a swap can always be
          undone), then badged ones (Selected by Dr. Baumann, then Best seller,
          then Sponsored), then the rest in the existing order. Then
          "Don't see one you like? See all {X} for {TYPE}", same tab, to the
          step's collection filtered to the type.
   BADGES (Luis, 10-02), both arms, on every card, the product in use included
   (the step carries badges too): "dr_pick" = "Selected by Dr. Baumann",
   "best_seller" = "Best seller", "sponsored" = "Sponsored" with an info button
   that opens "Brands can pay to be featured; ...". Source: the candidate's
   `badges` from the backend (skin-type-pro THEME2-STP-SWAP-BADGES), plus the
   product metafields sts.dr_pick / sts.sponsored that snippets/sts-ab.liquid
   prints (STS_AB.marks) for the products Liquid can see. A card with several
   shows them all, in that order.
   Theme settings "Routine picker A/B test" (window.STS_AB.on) and "percent in
   few" (STS_AB.few): off = no arm, every picker exactly as before. 0 or 100
   puts everyone in one arm; anything between keeps each device's stored arm.

   RECORDED: the arm rides on quiz/results `assignments` (routine_picker), as
   the GA4 user property ab_routine_picker (not from the staff simulator), and
   as `arm` on sts_routine_picker_open / sts_routine_swap / sts_routine_see_all
   (assets/sts-track.js: never an ad pixel) and the pages' add-to-cart events.
   sts_routine_swap's `badge` is the pick's first badge in the order above, or
   'none'. STS.ab.log holds this page's A/B events for QA, simulated ones
   included.

   QA, unpublished theme only: &sts_ab=all | few | off forces the arm in this
   tab (sessionStorage "sts.ab.sim", never the device's stored arm) and logs
   each event to the console as [sts-ab]; the simulator fixture then carries
   8 options per step, the last three badged dr_pick, sponsored, best_seller
   (assets/sts-simulator.js). */
(function (w, d) {
  'use strict';
  var STS = (w.STS = w.STS || {});
  if (STS.ab) return;
  var CFG = w.STS_AB || {};
  var KEY = 'sts.ab.routine_picker', SIM = 'sts.ab.sim';
  var arms = { all: 1, few: 1 };
  var memo, log = [], narrowed = false;
  var WIDE = /\/(widget\/regimen|profile(\/reset)?|routine\/(steps\/[^/?]+\/(swap|remove|restore)|budget-apply|add|quantities|extras\/[^/?]+\/remove))(\?|$)/;

  function store(s) { try { return s ? w.sessionStorage : w.localStorage; } catch (e) { return null; } }
  function get(s, k) { try { return store(s).getItem(k); } catch (e) { return null; } }
  function put(s, k, v) { try { store(s).setItem(k, v); return true; } catch (e) { return false; } }

  function unpublished() {
    var r = String((w.__STS_SERVER__ || {}).themeRole || ''), t = w.Shopify && w.Shopify.theme;
    return !!r && r !== 'main' && !(t && t.role === 'main');
  }

  /* The QA override: this tab only, never on the published theme. */
  function forced() {
    if (!unpublished()) return null;
    var m = /[?&]sts_ab=(all|few|off)\b/.exec(w.location.search);
    if (m) put(1, SIM, m[1]);
    var v = m ? m[1] : get(1, SIM);
    return v === 'off' || arms[v] ? v : null;
  }

  function arm() {
    if (memo !== undefined) return memo;
    var f = forced();
    if (f) return (memo = f === 'off' ? null : f);
    if (!CFG.on) return (memo = null);
    var pct = Number(CFG.few);
    if (!(pct >= 0 && pct <= 100)) pct = 50;
    if (pct === 0 || pct === 100) return (memo = pct ? 'few' : 'all');
    var v = get(0, KEY) || get(1, KEY);
    if (!arms[v]) v = Math.random() * 100 < pct ? 'few' : 'all';
    if (!put(0, KEY, v)) put(1, KEY, v);
    return (memo = v);
  }

  function simulated() {
    var st = STS.state;
    return !!(st && typeof st === 'object' && (st.source === 'preview' || (st.flags && st.flags.preview)));
  }

  /* Rank order: the few arm's sort and the swap event's `badge`. */
  var RANK = ['dr_pick', 'best_seller', 'sponsored'];
  var LABEL = { dr_pick: 'Selected by Dr. Baumann', best_seller: 'Best seller', sponsored: 'Sponsored' };
  var LOOK = {
    dr_pick: 'background:var(--sts-navy,#2F3572);color:#fff',
    best_seller: 'background:var(--sts-warn-bg,#FFF6E3);color:var(--sts-warn-ink,#7a5a12)',
    sponsored: 'background:var(--sts-surface-muted,#F1F1F3);color:#4A4C52'
  };
  var MARKS = CFG.marks || {}, uid = 0;

  /* A candidate's (or step's) badges, rank order. */
  function badges(c) {
    if (!c) return [];
    var have = [].concat(Array.isArray(c.badges) ? c.badges : [],
      MARKS[String(c.dtcVariantId).split('/').pop()] || [], (c.handle && MARKS[c.handle]) || []);
    return RANK.filter(function (b) { return have.indexOf(b) > -1; });
  }
  function rank(c) { var b = badges(c); return b.length ? RANK.indexOf(b[0]) : RANK.length; }
  function best(c) { return badges(c).indexOf('best_seller') > -1; }

  /* "Sponsored"'s disclosure: a real button (tap, Enter, Space) and the line
     it shows, [button, panel]. `label`: a text button instead of the icon. */
  function why(label, css) {
    var b = d.createElement('button'), p = d.createElement('span'), id = 'sts-ab-why-' + ++uid;
    b.type = 'button';
    b.setAttribute('aria-expanded', 'false');
    b.setAttribute('aria-controls', id);
    if (!label) b.setAttribute('aria-label', 'Why sponsored?');
    b.textContent = label || 'ⓘ';
    b.style.cssText = 'border:0;background:none;padding:0;font-family:inherit;color:inherit;text-transform:none;letter-spacing:0;cursor:pointer;' +
      (css || 'display:inline-flex;align-items:center;justify-content:center;width:24px;height:24px;margin:-6px -6px -6px 0;font-size:13px;line-height:1;vertical-align:middle');
    p.id = id;
    p.hidden = true;
    p.textContent = 'Brands can pay to be featured; every option here is approved for your skin type.';
    p.style.cssText = 'width:100%;font-size:11.5px;font-weight:400;line-height:1.35;letter-spacing:0;text-transform:none;color:#4A4C52';
    b.onclick = function (e) {
      e.stopPropagation();
      p.hidden = !p.hidden;
      b.setAttribute('aria-expanded', String(!p.hidden));
    };
    return [b, p];
  }

  function core() { return (w.STSRoutine || {}).core || {}; }

  /* "moisturizer", "eye_cream"; the slot itself when it names no category. */
  function stepKey(slot) {
    var c = core().categoryForSlot ? core().categoryForSlot(slot) : null;
    return c ? c.toLowerCase().replace(/\W+/g, '_') : String(slot || '').toLowerCase();
  }

  function alts(entries) { return (entries || []).filter(function (e) { return !e.isCurrent; }); }

  function track(name, params) {
    var a = arm();
    if (!a) return;
    var p = { arm: a }, k;
    for (k in params) if (Object.prototype.hasOwnProperty.call(params, k)) p[k] = params[k];
    if (log.length < 100) log.push({ event: name, params: p, simulated: simulated() });
    if (forced() && w.console) w.console.info('[sts-ab]', name, p);
    if (typeof w.stsTrack === 'function') w.stsTrack(name, p);
  }

  /* The step family -> [collection handle, words]. Each handle checked on the
     store 2026-09-29, with the skin-type filter live on it. Treatment steps go
     to serums: most treatment products are serums, and /collections/treatments
     is a grab bag (silicone gels, patches, a light device). */
  var COLL = {
    C: ['cleansers', 'Cleansers'],
    M: ['moisturizers', 'Moisturizers'],
    T: ['serums', 'Serums'],
    S: ['sun-protection', 'Sunscreens'],
    SPF: ['sun-protection', 'Sunscreens'],
    E: ['eye-creams', 'Eye Creams'],
    EX: ['exfoliators', 'Exfoliators'],
    TN: ['toners', 'Toners']
  };

  /* Fills (or makes) the few arm's link. Anything else: null, nothing drawn. */
  function seeAll(a, slot, type, surface) {
    type = String(type || '').toUpperCase();
    if (arm() !== 'few' || !/^[DO][SR][PN][TW]$/.test(type)) return null;
    var fam = core().slotFamily ? core().slotFamily(slot) : '';
    var hit = COLL[fam];
    /* No step family: everything approved for the type (snippets/sts-skin-types.liquid shop_url). */
    var href = '/collections/' + (hit ? hit[0] : 'all') + '?filter.p.m.product_info.baumann_skin_type_info=' + type;
    a = a || d.createElement('a');
    a.href = typeof STS.keepPreview === 'function' ? STS.keepPreview(href) : href;
    a.removeAttribute('target');
    a.removeAttribute('rel');
    a.textContent = 'Don’t see one you like? See all ' + (hit ? hit[1] : 'products') + ' for ' + type;
    a.hidden = false;
    a.setAttribute('data-sts-ab-seeall', '');
    a.onclick = function () { track('sts_routine_see_all', { step: stepKey(slot), surface: surface }); };
    return a;
  }

  /* The card's badges as a fragment of pills (each `cls` + `css`), null with
     none or no arm. "Sponsored" carries its disclosure, the line as a
     full-width sibling, unless `bare`: a pill inside a button (the results
     page's phone tiles) takes no button; sponsorNote() goes under the row. */
  function badge(c, cls, css, bare) {
    var list = arm() ? badges(c) : [];
    if (!list.length) return null;
    var f = d.createDocumentFragment();
    list.forEach(function (k) {
      var s = d.createElement('span'), w;
      if (cls) s.className = cls;
      s.setAttribute('data-tag', k);
      s.style.cssText = (css || '') + LOOK[k];
      s.textContent = LABEL[k];
      f.appendChild(s);
      if (k === 'sponsored' && !bare) {
        w = why();
        s.appendChild(d.createTextNode(' '));
        s.appendChild(w[0]);
        f.appendChild(w[1]);
      }
    });
    return f;
  }

  /* GA4 user property, once per page, after every deferred script has run (the
     staff simulator sets its state late), and never from a simulated state. */
  var told = false;
  function announce() {
    var a = arm();
    if (told || !a || simulated()) return;
    told = true;
    var dl = (w.dataLayer = w.dataLayer || []);
    dl.push({ ab_routine_picker: a });
    if (typeof w.gtag === 'function') w.gtag('set', 'user_properties', { ab_routine_picker: a });
    else dl.push({ event: 'sts_user_properties', user_properties: { ab_routine_picker: a } });
  }
  d.addEventListener('DOMContentLoaded', announce);
  w.addEventListener('load', announce);

  STS.ab = {
    arm: arm,
    forced: forced,
    log: log,
    best: best,
    badges: badges,
    badge: badge,
    /* Under a row whose pills are `bare` (inside buttons): the disclosure
       once, when any entry shows "Sponsored". */
    sponsorNote: function (entries) {
      if (!arm() || !(entries || []).some(function (e) { return badges(e.candidate).indexOf('sponsored') > -1; })) return null;
      var w = why('About “Sponsored”', 'min-height:44px;font-size:12.5px;font-weight:600;color:#2F3572;text-decoration:underline;text-underline-offset:3px'),
        box = d.createElement('div');
      box.appendChild(w[0]);
      box.appendChild(w[1]);
      return box;
    },
    seeAll: seeAll,
    /* The quiz/results `assignments`, with the arm when there is one. */
    assignments: function (base) {
      var a = arm(), out = {}, k;
      for (k in base) if (Object.prototype.hasOwnProperty.call(base, k)) out[k] = base[k];
      if (a) out.routine_picker = a;
      return out;
    },
    /* Any URL; arm "all" adds swaps=all where the backend admits it (skin-type-pro
       #1093): /widget/regimen and every proxy route that answers with the
       RoutineDoc, the writes too, or a write's re-render falls back to 5. The
       proxy SIGNS the query, so another route (budget-options, ack-change,
       cash, subscription...) would answer 401: never there. `method` 'GET'
       is left alone: only the pickers' own reads (no method; they retry plain
       on a 401) need the list, and another module's read feeds no picker. */
    swaps: function (url, method) {
      return arm() === 'all' && !narrowed && method !== 'GET' && WIDE.test(url) ? url + (url.indexOf('?') < 0 ? '?' : '&') + 'swaps=all' : url;
    },
    /* A proxy that refused swaps=all once (a backend without #1093): not again
       on this page, so no write is refused for it. */
    narrow: function () { narrowed = true; },
    /* The picker's entries (DRAWER.candidateEntries) as this arm shows them.
       "all": only approved options where the payload says (RoutineDoc
       candidates carry `approved`; /widget/regimen ones carry none and stay). */
    picker: function (entries) {
      if (arm() === 'all') return entries.filter(function (e) { return e.isCurrent || e.isOriginal || e.candidate.approved !== false; });
      if (arm() !== 'few') return entries;
      var head = [], orig = [], top = [], rest = [];
      entries.forEach(function (e) {
        (e.isCurrent ? head : e.isOriginal ? orig : rank(e.candidate) < RANK.length ? top : rest).push(e);
      });
      /* Stable: within a badge, the existing order. */
      top.sort(function (a, b) { return rank(a.candidate) - rank(b.candidate); });
      return head.concat(orig.concat(top, rest).slice(0, 3));
    },
    open: function (slot, entries, surface) {
      track('sts_routine_picker_open', { step: stepKey(slot), options_shown: alts(entries).length, surface: surface });
    },
    /* position: 1 = the first alternative under the product in use. */
    swap: function (slot, entries, entry, surface) {
      var i = alts(entries).indexOf(entry);
      track('sts_routine_swap', {
        step: stepKey(slot), position: i < 0 ? null : i + 1,
        badge: (entry && badges(entry.candidate)[0]) || 'none', surface: surface
      });
    }
  };
}(window, document));
